<template>
	<tbody class=" text-center ">
		<tr class="customtableloading " v-if="type == 'table' && pageloader_value" >
		    <td class="loader" :colspan="colspan" > 
				<!-- <img src="../../../../static/fxView/images/loading.svg" alt="no record found" class="loading-new"> -->
		  	</td>
		</tr>
		<tr  v-else-if="type == 'table' && ((list != '' && list.totalRecords == 0) || Object.keys(list).length  == 0) && !pageloader_value">
		    <td class="noRecordFound "  :colspan="colspan"> 
				<img src="../../../../static/fxView/images/search.svg" alt="no record found">
				<p>{{$t('load_norecordfound')}}</p>
		  	</td>
		</tr>
		<tr  v-else-if="type == 'table'  && !pageloader_value && (list == '' || list == null)">
		    <td class="noRecordFound "  :colspan="colspan"> 
				<img src="../../../../static/fxView/images/search.svg" alt="no record found">
				<p>{{$t('load_norecordfound')}}</p>
		  	</td>
		</tr>
	</tbody>
</template>
<script>
	import { fxViewMixins } from '@/plugins/fxView'
	export default {
		name: 'LoaderComponent',
		mixins: [fxViewMixins],
		data() {
			return { }
		},
		props:['pageloader_value','type','colspan','list']
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/loader_component.vue